import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Card, CardBody } from '../../../../components/card/card.jsx';
import { useTranslation } from 'react-i18next';
import { GetElementType } from '../../../../store/HR/Payroll/payrollElementSlice.js';
import ModalComponent from '../../../../components/Modal/ModalComponent.jsx';
import AddPayrollElement from './AddPayrollElement.jsx';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { usePermissions } from '../../../../Helper/Permisstions/usePermissions';
import Loading from '../../../../components/Shared/Loader/Loading';
import EditElementType from './EditElementType.jsx';
import NtxTable from '../../../../components/DataTable/NtxTable.jsx';

const PayrollElement = () => {
  const { HasPermission } = usePermissions();

  const { t, i18n } = useTranslation();
  const [ElementId, setElementId] = useState('');

  // Get all Payrolls from store
  const dispatch = useDispatch();
  const { ElementTypeList, loading, error } = useSelector(state => state.PyrollElement);
  const {
    ClassificationList,
    loading: loading3,
    error: error2
  } = useSelector(state => state.PyrollElement);

  useEffect(() => {
    if (ElementTypeList?.length === 0) {
      dispatch(GetElementType());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  //________________________________
  const columns = [
    { title: t('Name'), key: 'Name' },
    { title: t('Classification'), key: 'class' },
    // { title: t('نوع العنصر'), key: 'type' },
    { title: t(''), key: 'action', className: 'text-end', sortable: false }
  ];

  const tableData = ElementTypeList?.map(item => {
    return {
      Name: i18n.language === 'ar' ? item.name2 : item.name,
      class:
        i18n.language === 'en'
          ? ClassificationList?.find(f => f.id === item.classificationId)?.name
          : ClassificationList?.find(f => f.id === item.classificationId)?.name2,
      action: (
        <>
          {HasPermission('PayElementPayrollLink') && (
            <button
              type='button'
              onClick={() => setElementId(item.id)}
              // onClick={() => Navigate(`${item.id}/EditElementType`)}
              className='btn btn-sm btn-outline-theme  me-1'
              data-bs-toggle='modal'
              data-bs-target='#modalEditPayrollElement'
            >
              <i className='far fa-lg fa-fw me-2 fa-edit'></i>
              {t('Button.Edit')}
            </button>
          )}
        </>
      )
    };
  });
  //________________________________
  var BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome'
    },
    {
      name: t('PayrollElements'),
      link: null
    }
  ];

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb BreadcrumbList={BcrumbList} PageName={t('PayrollElements')} />

        {HasPermission('PayAddNewElement') && (
          <div className='ms-auto'>
            <Link
              to=''
              className='btn btn-theme me-1'
              data-bs-toggle='modal'
              data-bs-target='#modalAddPayrollElement'
              // onClick={() => setShow(true)}
            >
              <i className='fa fa-plus-circle fa-fw me-1'></i> {t('AddPayrollElement')}{' '}
            </Link>
          </div>
        )}
      </div>

      <Card>
        <Loading loading={loading || loading3} error={error || error2}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent id='modalAddPayrollElement' title={t('AddPayrollElement')}>
        {true && <AddPayrollElement />}
      </ModalComponent>

      <ModalComponent id='modalEditPayrollElement' title={t('EditPayrollElement')}>
        {ElementId && <EditElementType id={ElementId} />}
      </ModalComponent>
    </>
  );
};
export default PayrollElement;
